import React from "react";
import Profile from "./../../Components/profile";
import { SnackbarProvider } from "notistack";
function ProfilePage() {
  return (
    <SnackbarProvider>
      <div>
        <Profile />
      </div>
    </SnackbarProvider>
  );
}

export default ProfilePage;
